import * as AT from 'redux/actionTypes';

export const tryAuthenticateFromLocalStorage = (profile) => ({
  type: AT.TRY_AUTHENTICATE_FROM_LOCAL_STORAGE,
  payload: profile,
});

export const finishedTryToAuthenticateFromLocalStorage = () => ({
  type: AT.FINISHED_TRY_AUTHENTICATE_FROM_LOCAL_STORAGE,
  payload: {},
});

export const loginSuccess = (profile, scope, accessToken, expiresAt, extras = {}) => ({
  type: AT.LOGIN_SUCCESS,
  payload: {
    profile,
    scope,
    accessToken,
    expiresAt,
    issuedAt: extras.issuedAt ?? null,
    generationId: extras.generationId ?? null,
    sessionStatus: extras.sessionStatus ?? 'authenticated',
    authenticationReason: extras.authenticationReason ?? null,
  },
});

export const logout = () => ({
  type: AT.LOGOUT,
  payload: {},
});

export const internalUserIdResolved = (auth0UserId, userId) => ({
  type: AT.AUTH_INTERNAL_USER_ID_RESOLVED,
  payload: { auth0UserId, userId },
});

export const logoutAfterAuthenticationFailure = () => logout();

export const renewToken = (accessToken, scope, extras = {}) => ({
  type: AT.RENEW_TOKEN,
  payload: {
    accessToken,
    scope,
    issuedAt: extras.issuedAt ?? null,
    expiresAt: extras.expiresAt ?? null,
    generationId: extras.generationId ?? null,
  },
});

export const publishAuthSessionSnapshot = (snapshot) => ({
  type: AT.AUTH_SESSION_SNAPSHOT,
  payload: snapshot,
});

export const authSessionDegraded = (reason) => ({
  type: AT.AUTH_SESSION_DEGRADED,
  payload: { reason },
});

export const authReauthenticationRequired = (reason) => ({
  type: AT.AUTH_REAUTHENTICATION_REQUIRED,
  payload: { reason },
});

export const authAuthenticationError = (reason) => ({
  type: AT.AUTH_AUTHENTICATION_ERROR,
  payload: { reason },
});
